import React from 'react'
import { useDispatch } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import { DRAWER_KEY, FIREBASE_EVENTS } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { BaseCard } from '../base-card'

export function AccountUnlockCard() {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  function handleClick() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_ACCOUNT_UNLOCK)
    dispatch(setDrawer(DRAWER_KEY.UNLOCK_ACCOUNT))
  }

  return <BaseCard onClick={handleClick} text='Desbloqueio de conta' icon={<STATICS.LOCK />} />
}
